import { Box, FlexLayout, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { useState } from 'react';
import { TwitterPicker } from 'react-color';

type RelationIndicatorProps = {
  color: string;
  onChange?: (pickedColor: string) => void;
};
const RelationIndicator: FC<RelationIndicatorProps> = ({ color, onChange }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleColorPickerChange = pickedColor => {
    if (onChange) {
      onChange(pickedColor.hex);
    }
    setDisplayColorPicker(false);
  };

  return (
    <Box
      boxShadow="subtle"
      style={{
        position: 'relative',
        height: '90px',
        width: '2px',
        backgroundColor: color
      }}
    >
      <FlexLayout
        alignItems="center"
        justifyContent="center"
        bg="white"
        boxShadow="subtle"
        onClick={() => setDisplayColorPicker(true)}
        style={{
          position: 'absolute',
          top: 'calc(50% -  16px)',
          left: 'calc(50% -  16px)',
          border: '1px solid #DADFE4',
          boxSizing: 'border-box',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          cursor: 'pointer'
        }}
      >
        <Icon src="paletteRounded" stroke="transparent" css={{ color }} />
      </FlexLayout>
      {displayColorPicker && (
        <Box style={{ transform: 'translate(-20px,55px)' }}>
          <TwitterPicker onChange={handleColorPickerChange} />
        </Box>
      )}
    </Box>
  );
};

export default RelationIndicator;
